import type { Element } from "React";
type Props = {
  className?: string;
  pointingRight: boolean;
};

const DangerZoneArrows = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="12"
    viewBox="0 0 32 12"
    className={props.className}
  >
    <title id="title">Danger Zone Arrows</title>
    {props.pointingRight ? (
      <g>
        <path d="M4 0h4l8 6-8 6H4l8-6z" />
        <path d="M12 0h4l8 6-8 6h-4l8-6z" />
        <path d="M20 0h4l8 6-8 6h-4l8-6zM0 0l8 6-8 6V6z" />
      </g>
    ) : (
      <g>
        <path d="M28 12h-4l-8-6 8-6h4l-8 6z" />
        <path d="M20 12h-4L8 6l8-6h4l-8 6z" />
        <path d="M12 12H8L0 6l8-6h4L4 6zM32 12l-8-6 8-6v6z" />
      </g>
    )}
  </svg>
);

export default DangerZoneArrows;
